if (!customElements.get("custom-swiper")) {
  customElements.define(
    "custom-swiper",

    class CustomSwiper extends HTMLElement {
      constructor() {
        super();

        this.swiperId = this.getAttribute("id");
        this.swiperOptions = JSON.parse(
          this.querySelector("[id^=SwiperOptions]").innerHTML
        );

        this.init();

        document.addEventListener("shopify:section:load", (event) => {
          if (event.target.querySelector("custom-swiper")) this.init();
        });

        document.addEventListener("shopify:section:reorder", (event) => {
          if (event.target.querySelector("custom-swiper")) this.init();
        });
      }
      init() {
        new Swiper(`#${this.swiperId} .swiper`, {
          ...this.swiperOptions,

          on: {
            slideChangeTransitionEnd: function () {
              window.recalculate();
            },
          },
        });
      }
    }
  );
}
